<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" style="background-image:url(images/shapes_g.jpg); background-repeat:no-repeat; background-position: left left;">
<h1 class="SOM_titre" epub:type="title"> </h1>
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">P<span class="small">REFACE TO THE </span>S<span class="small">ECOND</span> E<span class="small">DITION</span></a></div>
<div class="SOM_pre"><a href="#/pre3">A<span class="small">CKNOWLEDGMENTS</span></a></div>
<div class="SOM_chap"><a href="#/chap1"><i><b>1</b></i> Where Do I Start?</a></div>
<div class="SOM_chap"><a href="#/chap2"><i><b>2</b></i> What Is Real?<br/>
<span class="tab"><i>Metaphysics</i></span></a></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><i><b>3</b></i> How Do I Know?<br/>
<span class="tab"><i>Epistemology</i></span></span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><i><b>4</b></i> How Should I Live?<br/>
<span class="tab"><i>Ethics</i></span></span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><i><b>5</b></i> What Am I?<br/>
<span class="tab"><i>Philosophical and Theological Anthropology</i></span></span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><i><b>6</b></i> How Should Christians Think About Science?<br/>
<span class="tab"><i>Philosophy of Science</i></span></span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><i><b>7</b></i> What Is Beauty? What About Art?<br/>
<span class="tab"><i>Aesthetics</i></span></span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><i><b>8</b></i> What Should We Worship?<br/>
<span class="tab"><i>Philosophy of Religion</i></span></span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><i><b>9</b></i> Where Do I Go from Here?<br/>
<span class="tab"><i>Worldview Struggle and Intellectual Crisis</i></span></span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">F<span class="small">OR</span> F<span class="small">URTHER</span> R<span class="small">EADING</span></span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">S<span class="small">UBJECT</span> I<span class="small">NDEX</span></span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">S<span class="small">CRIPTURE</span> I<span class="small">NDEX</span></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">N<span class="small">OTES</span></span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">P<span class="small">RAISE FOR</span> <i>P<span class="small">HILOSOPHY</span> M<span class="small">ADE</span> S<span class="small">LIGHTLY</span> L<span class="small">ESS</span> D<span class="small">IFFICULT</span></i></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">A<span class="small">BOUT THE </span>A<span class="small">UTHORS</span></span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">M<span class="small">ORE</span> T<span class="small">ITLES FROM</span> I<span class="small">NTERVARSITY</span> P<span class="small">RESS</span></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?90eaf828